import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { getTestimonials } from "@/i18n/testimonials";

export const TestimonialsCarousel = ({ family, lang, items: itemsProp, title, subtitle, className = "bg-slate-50" }) => {
  const items = itemsProp?.length ? itemsProp : getTestimonials(family, lang);
  if (!items?.length) return null;
  return (
    <section className={`py-16 ${className}`} data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-slate-900">
            {title || (lang === "nl" ? "Zij vonden hun vakman via DevisMaison.be" : "Ils ont trouvé leur artisan via DevisMaison.be")}
          </h2>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-sm text-slate-500">{subtitle || (lang === "nl" ? "Geverifieerde klantervaringen" : "Expériences clients vérifiées")}</span>
          </div>
        </div>
        <Carousel opts={{ align: "start", loop: true }} className="px-1">
          <CarouselContent>
            {items.map((t, i) => (
              <CarouselItem key={i} className="md:basis-1/2" data-testid={`testimonial-${i}`}>
                <div className="h-full bg-white rounded-2xl border border-slate-200 p-8 flex flex-col">
                  <Quote className="w-8 h-8 text-orange-200 mb-4" />
                  <p className="text-slate-700 leading-relaxed flex-1">"{t.text}"</p>
                  <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-100">
                    <div>
                      <p className="font-semibold text-slate-900">{t.name}</p>
                      <p className="text-sm text-slate-500">{t.city}{t.date ? ` · ${t.date}` : ""}</p>
                    </div>
                    <div className="flex">
                      {[1, 2, 3, 4, 5].map((s) => (
                        <Star key={s} className={`w-4 h-4 ${s <= t.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"}`} />
                      ))}
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="hidden md:block">
            <CarouselPrevious className="-left-4" data-testid="testimonials-prev" />
            <CarouselNext className="-right-4" data-testid="testimonials-next" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
